import moment from "moment";
import momentTimeZone from "moment-timezone";
import config from "../config/config";
import { boxesMainCategoryKey, boxesSubCategoryKey, boxigoBoxesSubCategoryKey } from "../constants/inventory";
import { boxigo_logo_img_data, footer_bg } from "../assets/base64/fontBase64";

const formatAddressData = (data) => {
  if (data !== undefined && data !== "" && data !== null) {
    return data;
  }
  return "";
};

const getFromAddress = (fromAddressBreakDown) => {
  let fromAddress = [];
  let address = formatAddressData(fromAddressBreakDown["fromAddress"]);
  let locality = formatAddressData(fromAddressBreakDown["fromLocality"]);
  let city = formatAddressData(fromAddressBreakDown["fromCity"]);
  let state = formatAddressData(fromAddressBreakDown["fromState"]);
  let pincode = formatAddressData(fromAddressBreakDown["pincode"]);
  if (address !== "") {
    fromAddress.push(address);
  }
  if (locality !== "") {
    fromAddress.push(locality);
  }
  if (city !== "") {
    fromAddress.push(city);
  }
  if (state !== "") {
    fromAddress.push(state);
  }
  if (pincode !== "") {
    fromAddress.push(pincode);
  }
  return fromAddress.join(", ");
};

const getToAddress = (toAddressBreakDown) => {
  let toAddress = [];
  let address = formatAddressData(toAddressBreakDown["toAddress"]);
  let locality = formatAddressData(toAddressBreakDown["toLocality"]);
  let city = formatAddressData(toAddressBreakDown["toCity"]);
  let state = formatAddressData(toAddressBreakDown["toState"]);
  let pincode = formatAddressData(toAddressBreakDown["pincode"]);
  if (address !== "") {
    toAddress.push(address);
  }
  if (locality !== "") {
    toAddress.push(locality);
  }
  if (city !== "") {
    toAddress.push(city);
  }
  if (state !== "") {
    toAddress.push(state);
  }
  if (pincode !== "") {
    toAddress.push(pincode);
  }
  return toAddress.join(", ");
};

export function getInquiryDetails(all_details, name, email, phone, alternatePhone) {
  const date_created = all_details.date_created;
  const items = all_details.items;
  all_details.itemsList = [];
  all_details.custom = [];
  all_details.boxes = [];
  let boxes_count = 0;
  let custom_count = 0;
  let item_count = 0;

  const fromAddressBreakDown = all_details.from_address;
  const fromCity = fromAddressBreakDown["fromCity"];

  const toAddressBreakDown = all_details.to_address;
  const toCity = toAddressBreakDown["toCity"];

  // const getSelectedList = (list) => {
  //   return list.filter((listItem) =>
  //     listItem.selected === true ? true : false
  //   );
  // };
  // const getCombinedData = (name_array, item) => {
  //   if (item.meta.hasType === true) {
  //     let selectedType = getSelectedList(item.type);
  //     selectedType.forEach((type) => {
  //       name_array.push(type.option);
  //     });
  //   }
  //   if (item.meta.hasSize === true) {
  //     let selectedSize = getSelectedList(item.size);
  //     selectedSize.forEach((type) => {
  //       name_array.push(type.option);
  //     });
  //   }
  //   return name_array;
  // };
  if (items !== null) {
    const inventory = items.inventory;
    inventory.forEach((mainCategory) => {
      mainCategory.category.forEach((subCategory) => {
        subCategory.items.forEach((item) => {
          if (parseInt(item.qty) > 0) {
            var name_array = [item.displayName];
            // name_array = getCombinedData(name_array, item);
            if (name_array.length > 0) {
              var item_name = "";
              name_array.length === 1
                ? (item_name = name_array)
                : (item_name = name_array.join(" | "));
            }
            if (
              (mainCategory.name).includes(boxesMainCategoryKey) &&
              (subCategory.name === boxesSubCategoryKey || subCategory.name === boxigoBoxesSubCategoryKey)
            ) {
              boxes_count += parseInt(item.qty);
              all_details.boxes.push({
                name: item_name,
                qty: item.qty,
              });
            } else {
              item_count += parseInt(item.qty);
              all_details.itemsList.push({
                name: item_name,
                qty: item.qty,
              });
            }
            // if (item.childItems.length > 0) {
            //   item.childItems.forEach((childItem) => {
            //     name_array = [childItem.displayName];
            //     name_array = getCombinedData(name_array, childItem);
            //     if (name_array.length > 0) {
            //       item_name = "";
            //       name_array.length === 1
            //         ? (item_name = name_array)
            //         : (item_name = name_array.join(" | "));
            //     }
            //     if (
            //       mainCategory.name === boxesMainCategoryId &&
            //       subCategory.name === boxesSubCategoryId
            //     ) {
            //       boxes_count += parseInt(childItem.qty);
            //       all_details.boxes.push({
            //         name: item_name,
            //         qty: childItem.qty,
            //       });
            //     } else {
            //       item_count += parseInt(childItem.qty);
            //       all_details.itemsList.push({
            //         name: item_name,
            //         qty: childItem.qty,
            //       });
            //     }
            //   });
            // }
          }
        });
      });
    });

    if (items.customItems.items.length > 0) {
      const pdf_units = items.customItems.units === "feet" ? "ft" : "mts";
      items.customItems.items.forEach((item) => {
        if (item.item_qty > 0) {
          custom_count += parseInt(item.item_qty);
          all_details.custom.push({
            name:
              item.item_name +
              " (L:" +
              item.item_length +
              "* W:" +
              item.item_width +
              "* H:" +
              item.item_height +
              ") " +
              pdf_units,
            description: item.item_description,
            qty: item.item_qty,
          });
        }
      });
    }
  }
  all_details.items_count = item_count;
  all_details.boxes_count = boxes_count;
  all_details.custom_count = custom_count;
  const data = {
    room: all_details.itemsList,
    custom: all_details.custom,
    boxes: all_details.boxes,
    boxes_count: all_details.boxes_count,
    items_count: all_details.items_count,
    custom_count: all_details.custom_count,
    property_size: all_details.property_size,
    total_items: all_details.total_items,
    moving_on: all_details.moving_on,
    moving_from: getFromAddress(fromAddressBreakDown),
    moving_to: getToAddress(toAddressBreakDown),
    from_city: fromCity,
    to_city: toCity,
    distance: all_details.distance,
    new_floor_no: all_details.new_floor_no,
    old_floor_no: all_details.old_floor_no,
    new_elevator_availability: all_details.new_elevator_availability,
    old_elevator_availability: all_details.old_elevator_availability,
    email: email,
    name: name,
    phone: phone,
    customer_alternate_phone: alternatePhone ? alternatePhone : "",
    font_url: config.customerPortal + "assets/fonts/",
    date_created: date_created,
    storage_items: all_details.storage_items,
    service_type: all_details.service_type,
    old_parking_distance: all_details.old_parking_distance,
    new_parking_distance: all_details.new_parking_distance,
    additional_info: all_details.old_house_additional_info,
    days_of_storage: all_details.days_of_storage,
    version: all_details.version
  };
  return data;
}

export function getOrderSummaryDetails(data, paymentData, customerInfo) {
  const fromAddressBreakDown = data["from_address"];
  const fromCity = fromAddressBreakDown["fromCity"];
  const fromPincode = fromAddressBreakDown["pincode"];
  const toAddressBreakDown = data["to_address"];
  const toCity = toAddressBreakDown["toCity"];
  const toPincode = toAddressBreakDown["pincode"];

  const movingOn = data["moving_on"];
  const transactionTime = paymentData["transaction_time"];
  const totalInvoiceAmount = data["estimateAmount"]["invoiceAmount"];
  const orderSummary = {
    name: customerInfo["name"],
    phone: customerInfo["phone"],
    customer_alternate_phone: customerInfo["alternatePhone"],
    email: customerInfo["email"],
    property_size: data["property_size"],
    total_items: data["total_items"],
    moving_on: movingOn,
    moving_from: getFromAddress(fromAddressBreakDown),
    moving_to: getToAddress(toAddressBreakDown),
    from_city: fromCity,
    to_city: toCity,
    old_floor_no: data["old_floor_no"],
    new_floor_no: data["new_floor_no"],
    payment: {
      order_id: paymentData["order_id"],
      referenceId: paymentData["referenceId"],
      amount: paymentData["amount"],
      transaction_time: transactionTime,
      paymentMode: paymentData["paymentMode"],
      payment_type: paymentData["payment_type"],
    },
    total_invoice_amount: totalInvoiceAmount,
    font_url: config.customerPortal + "assets/fonts/",
    from_pincode: fromPincode,
    to_pincode: toPincode,
    payment_transaction_date: transactionTime,
  };
  return orderSummary;
}

export function getFinalInvoiceDetails(data, customerInfo) {
  const fromAddressBreakDown = data["from_address"];
  const toAddressBreakDown = data["to_address"];
  const estimateInvoiceData = data["estimateAmount"];
  const vendorQuoteData = data["estimate_comparison"][0];
  const order_date = data["order_date"];
  const completed_date = data["date_of_complete"];
  const billing_address = getToAddress(toAddressBreakDown);
  const from_pincode = fromAddressBreakDown["pincode"];
  const to_pincode = toAddressBreakDown["pincode"];
  const place_of_supply = toAddressBreakDown["toCity"];
  const quote = data["estimate_comparison"][0]["quote"];
  const tax_data = data["estimate_comparison"][0]["tax_name"] === null ? null : { tax_name: data["estimate_comparison"][0]["tax_name"], tax_value: data["estimate_comparison"][0]["tax_value"] };
  const logo = `${config.mainDomain}/vendors/${vendorQuoteData["vendor_id"]}/${vendorQuoteData["logo"]}`;
  const finalInvoiceDetails = {
    quote: quote,
    name: customerInfo["name"],
    phone: customerInfo["phone"],
    email: customerInfo["email"],
    customer_alternate_phone: customerInfo["alternatePhone"],
    logo: logo,
    business_name: vendorQuoteData["business_name"],
    vendor_address: vendorQuoteData["vendor_address"],
    pan_number: vendorQuoteData["pan_number"],
    GSTIN_number: vendorQuoteData["GSTIN_number"],
    order_date: order_date,
    billing_address: billing_address,
    place_of_supply: place_of_supply,
    payment_made: estimateInvoiceData["finalInvoiceAmt"],
    invoice_number: estimateInvoiceData["invoice_number"],
    vendor_id: data["vendor_id"],
    font_url: config.customerPortal + `assets/fonts/`,
    from_pincode: from_pincode,
    to_pincode: to_pincode,
    completed_date: completed_date,
    tax_data: tax_data
  };

  return finalInvoiceDetails;
}

function getClientTimezone() {
  const clientTZ = momentTimeZone.tz.guess();
  if (clientTZ !== undefined && clientTZ !== null && clientTZ !== "") {
    return clientTZ;
  }
  return "Asia/Calcutta";
}

export function generateInvoice(id, all_details, type, payment_type = false) {
  var title;
  var content;
  var invoice_number;

  var newdate = moment(new Date()).format("DD-MMM-YYYY");

  let imageObj = {
    image: boxigo_logo_img_data,
    height: 60,
    width: 151,
  };

  let imageObj2 = {
    image: boxigo_logo_img_data,
    width: 100,
  };
  switch (type) {
    case "inquiry":
      if (type === "inquiry") {
        newdate = momentTimeZone
          .utc(all_details.date_created)
          .tz(getClientTimezone())
          .format("DD-MMM-YYYY");
      }
      window.pdfMake.fonts = {
        Montserrat: {
          normal: "Montserrat-Regular.otf",
          bold: "Montserrat-SemiBold.otf",
          italics: "Montserrat-Regular.otf",
        },
      };
      title = "MOVE INQUIRY";
      //Room items
      let items = [];
      let item_title;
      let storage = {};
      let days_of_storage = {};
      if (all_details.service_type === "storage" && all_details.version === "v2") {
        days_of_storage = {
          stack: [
            {
              text: `Days of storage: ${all_details.days_of_storage}`,
              bold: true,
              margin: [0, 10, 0, 5],
            },
          ],
        };
      }
      if (all_details.service_type === "storage" && all_details.version === "v1") {
        storage = {
          stack: [
            {
              text: "The list of items to be packed and stored",
              bold: true,
              margin: [0, 16],
            },
            { text: all_details.storage_items },
          ],
        };
      }
      if (all_details.room.length > 0) {
        item_title = {
          text: all_details.service_type === "storage" ? "The list of items to be packed and stored" : "The list of items to be packed and moved",
          bold: true,
          margin: [0, 16],
        };
        items = [
          [
            {
              text: "Sl No.",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "List of items",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "Quantity",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
              alignment: "center",
            },
          ],
        ];
        all_details["room"].forEach((item, index) => {
          items.push([
            index + 1,
            item.name,
            { alignment: "center", text: item.qty },
          ]);
        });
        items.push([
          "",
          { text: "Total items", bold: true },
          { alignment: "center", bold: true, text: all_details["items_count"] },
        ]);
      } else {
        item_title = "";
        items = ["", "", ""];
      }

      //Boxes

      let boxes = [];
      if (all_details.boxes.length > 0) {
        boxes = [
          [
            {
              text: "Sl No.",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "List of boxes",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "Quantity",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
              alignment: "center",
            },
          ],
        ];
        all_details["boxes"].forEach((item, index) => {
          boxes.push([
            index + 1,
            item.name,
            { alignment: "center", text: item.qty },
          ]);
        });
        boxes.push([
          "",
          { text: "Total Boxes", bold: true },
          { alignment: "center", bold: true, text: all_details["boxes_count"] },
        ]);
      } else {
        boxes = ["", "", ""];
      }

      // console.log(all_details.custom);
      //Custom Items
      let custom = [];
      if (all_details.custom.length > 0) {
        custom = [
          [
            {
              text: "Sl No.",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "Custom items",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "Description",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
            },
            {
              text: "Quantity",
              style: "tableHeader",
              bold: true,
              color: "#EE553B",
              alignment: "center",
            },
          ],
        ];
        all_details["custom"].forEach((item, index) => {
          custom.push([
            index + 1,
            item.name,
            item.description,
            { alignment: "center", text: item.qty },
          ]);
        });
        custom.push([
          "",
          { text: "Total custom items", bold: true },
          "",
          {
            alignment: "center",
            bold: true,
            text: all_details["custom_count"],
          },
        ]);
      } else {
        custom = ["", "", "", ""];
      }

      //Content
      content = [
        {
          text: "Customer Details",
          color: "#EE553B",
          bold: true,
          margin: [0, 30, 0, 0],
        },
        {
          columns: [
            {
              width: "32%",
              stack: [
                { bold: true, text: "Name", margin: [0, 0, 0, 4] },
                all_details["name"],
              ],
            },
            {
              width: "32%",
              stack: [
                { bold: true, text: "Phone", margin: [0, 0, 0, 4] },
                `${all_details["phone"]}${all_details["customer_alternate_phone"] !== "" ? ", " + all_details["customer_alternate_phone"] : ""}`
              ],
            },
            {
              width: "32%",
              stack: [
                { bold: true, text: "Email", margin: [0, 0, 0, 4] },
                all_details["email"],
              ],
            },
          ],
          margin: [0, 4, 0, 8],
          columnGap: 15,
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 532,
              y2: 0,
              lineWidth: 1,
              lineColor: "#dedede",
            },
          ],
        },
        {
          columns: [
            {
              width: "32%",
              stack: [
                {
                  text: "Relocation Details",
                  bold: true,
                  margin: [0, 0, 0, 8],
                },
                {
                  text: [
                    { bold: true, text: "Property Size: " },
                    all_details["property_size"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Total Items: " },
                    all_details["total_items"] - all_details["boxes_count"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Boxes Required: " },
                    all_details["boxes_count"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Total Distance: " },
                    all_details["distance"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "DOS: " },
                    momentTimeZone
                      .utc(all_details["moving_on"])
                      .tz(getClientTimezone())
                      .format("MMM D[, ]YYYY hh:mm a"),
                  ],
                },
              ],
            },
            {
              width: "32%",
              stack: [
                { text: "Origin", bold: true, margin: [0, 0, 0, 8] },
                {
                  text: [
                    { text: "City: ", bold: true },
                    all_details["from_city"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { text: "Address: ", bold: true },
                    all_details["moving_from"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { text: "Floor: ", bold: true },
                    all_details["old_floor_no"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { text: "Service Lift: ", bold: true },
                    all_details["old_elevator_availability"],
                  ],
                },
                {
                  text: [
                    { text: "DTT: ", bold: true },
                    all_details["old_parking_distance"],
                  ],
                },
              ],
            },
            {
              width: "32%",
              stack: [
                { text: "Destination", bold: true, margin: [0, 0, 0, 8] },
                {
                  text: [
                    { text: "City: ", bold: true },
                    all_details["to_city"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Address: " },
                    all_details["moving_to"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Floor: " },
                    all_details["new_floor_no"],
                  ],
                  margin: [0, 0, 0, 4],
                },
                {
                  text: [
                    { bold: true, text: "Service Lift: " },
                    all_details["new_elevator_availability"],
                  ],
                },
                {
                  text: [
                    { text: "DTT: ", bold: true },
                    all_details["new_parking_distance"],
                  ],
                },
              ],
            },
          ],
          margin: [0, 5],
          columnGap: 15,
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 520,
              y2: 0,
              lineWidth: 1,
              lineColor: "#dedede",
            },
          ],
        },
        days_of_storage,
        {
          stack: [
            {
              text: "Additional Info",
              bold: true,
              margin: [0, 10, 0, 5],
            },
            {
              text:
                all_details["additional_info"] === ""
                  ? "No Additional Info Provided."
                  : all_details["additional_info"],
              margin: [0, 0, 0, 10],
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 520,
              y2: 0,
              lineWidth: 1,
              lineColor: "#dedede",
            },
          ],
        },
        storage,
        item_title,
        {
          table: {
            dontBreakRows: true,
            keepWithHeaderRows: 1,
            heights: 20,
            widths: [70, 368, 70],
            headerRows: 1,
            body: items,
          },
          layout: "noBorders",
        },
        {
          table: {
            dontBreakRows: true,
            keepWithHeaderRows: 1,
            heights: 20,
            widths: [70, 368, 70],
            headerRows: 1,
            body: boxes,
          },
          layout: "noBorders",
        },
        {
          table: {
            dontBreakRows: true,
            keepWithHeaderRows: 1,
            heights: 20,
            widths: [70, 184, 184, 70],
            headerRows: 1,
            body: custom,
          },
          layout: "noBorders",
        },
        {
          pageBreak: "before",
          text: "Important Points",
          color: "#ee553b",
          bold: true,
          alignment: "center",
          fontSize: "16",
          margin: [0, 16],
        },
        {
          text: "Customer Terms and Conditions:",
          bold: true,
          margin: [0, 8],
        },
        {
          markerColor: "#ee553b",
          ul: [
            {
              text: "The list is generated based on the input shared by you on Boxigo smart move planner or shared by you to our move coordinator.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "The above list cover dismantling/ re-assembling services of basic goods and furniture. Any sort of complex dismantling shall be charged separately. ",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Estimates which has not been confirmed within 60 days would be auto cancelled.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Classification of such furniture is as per the consent of the vendor and often includes modular furniture, Air conditioner, DTH antenna, Water purifier, Geyser, Wall-mounted cabinet, and Wall-mounted TVs.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Any addition in prices due to the last-minute change of items list shall be owned by the customer. Customer is inquired to make themselves aware of the items list on which the current quotations are based upon.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Quotations might vary if there is any modification in the destination or origin including the availability of appropriate service lift or floor information. It might also vary based on the restraints from the apartment complex etc. if not communicated before the start of the movement.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "All the luxury or high worth items (including but not limited to luxury watches, sunglasses, musical instruments, and showpieces) needs to be categorically mentioned to the move manager before making the final payment. Such items will not be covered under insurance unless they have been specifically mentioned as the list of inventory.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Any kind of explosives including LPG filled in a cylinder and Alcohol (and its derivatives) shall not be transported in any condition. In the case of gas cylinders or containers, it is the role of the customer to make sure that both of these are empty while relocation/Storage is being executed.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Pots/gardening items along with planted flowers will be transported entirely at the risk of the customer.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Dismantling/re-assembling instruments that require the manufacturer's assistance shall be taken care of by the customer itself.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Parties mutually recommend you to avail a comprehensive transit Insurance policy from Vendor or any third party insurance service provider.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Warehouse facility will be provided on demand at a location convenient to our service partner. In case of any specific requirement on the warehouse location, the client should categorically request for the same before the confirmation of the relocation.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "The 4-Wheeler will be driven to loading point at origin location and from the unloading point at destination location. Vehicles will be driven up to 250 km basis the availability of Car-carrier in the particular route and the client is requested to maintain the fuel to cover this distance. Documents like RC Copy, Insurance copy, Pollution check copy, Driving Licence/ Valid Government Id will be required for the relocation of the vehicles.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            {
              text: "Original documents are not required for relocating 4- Wheeler or 2- Wheeler. Proper pictures and video should be taken before the handover of the vehicle and all the details should be mentioned in the Goods Consignment Copy or Lorry Receipt.",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
            { text: "Boxigo will handle the dismantling of Geyser, TV, DTH, and RO systems, while the task of assembling them will be the customer's responsibility.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Glass items and chimneys will not be dismantled/assembled.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "If the customer needs any packing boxes (2W*1.5H*1.5B), price of each box would be Rs.80.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "A rope lifting service is required for the narrow staircase, and there may be additional charges associated with it.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Turn off the Fridge and washing machine 24 hours before packing and moving.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Foods, beverages, and Liquor items are prohibited.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Engineered Wood is delicate which are prone to damage for long-distance travel. Hence its recommended to be dismantled by the customer.", margin: [0, 0, 0, 8], fontSize: "8" },
            {
              text: "By accepting the quotations, you accept the Terms and Conditions, Privacy Policy, Answers to FAQ and Refund Policy of this website. ",
              margin: [0, 0, 0, 8],
              fontSize: "8",
            },
          ],
        },
        all_details.service_type === "storage" ?
          {
            pageBreak: "before",
            text: "Storage Terms:",
            bold: true,
            margin: [0, 8],
          } : {
            pageBreak: "before",
            text: "",
            bold: true,
            margin: [0, 8],
          },
        all_details.service_type === "storage" ? {
          markerColor: "#ee553b",
          ul: [
            { text: "Additional charges for transportation and unloading during the delivery of stored goods will be applied separately and will be charged extra at the time of delivery.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "If the items in the Inventory list are changed. There will be a revision in the estimate.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "It is common practice that full gas cylinders, will not be stored in warehouses or storage facilities. Instead, they would be emptied before being stored. This is done for safety reasons, as storing full cylinders can pose a risk due to their contents.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "You will need to make monthly payments for the storage belongings. If the monthly/yearly package is not subscribed to.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Breakdown of the payment schedule:", margin: [0, 0, 0, 8], fontSize: "8" },
            {
              ul: [{ text: "Move-in Date: The date when the storage subscription begins (e.g., 12th January)", margin: [0, 0, 0, 7], fontSize: "8" },
              { text: "Monthly Payment Date: The move-in day of every subsequent month (e.g., 12th February, 12th March, etc.)", margin: [0, 0, 0, 7], fontSize: "8" },
              { text: "Invoice Trigger Date: 2nd of every month (e.g., 2nd February, 2nd March, etc.)", margin: [0, 0, 0, 7], fontSize: "8" },
              { text: "Due Date: End of the same month (e.g., 31st January, 28th/29th February, etc.)", margin: [0, 0, 0, 7], fontSize: "8" },
              ]
            },
            { text: "It is important to make the monthly payments by the specified due date to avoid, any penalties. If a payment is delayed beyond the due date, there may be penalties imposed, and these penalties can amount to up to 10% of the outstanding amount.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "To ensure timely payments and avoid penalties, it is recommended to adhere to the payment schedule and settle the invoice by the end of each month.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "The customer is required to provide a minimum of one week's advance notice for item delivery. Short notice deliveries will not be accepted, as they can disrupt the service provider's planning and logistics.", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "Insurance coverage up to 2.5 Lacs against Fire, Burglary, Flood, and any natural calamities. ", margin: [0, 0, 0, 8], fontSize: "8" },
            { text: "For our storage service, KYC is mandatory, requiring customers to provide 2 valid, government-issued IDs like Aadhar and PAN cards. This meets government regulations. Customers consent to provide and verify these documents by storing items with us.", margin: [0, 0, 0, 8], fontSize: "8" },
          ]
        } : {},
        {
          table: {
            dontBreakRows: true,
            keepWithHeaderRows: 1,
            // heights: 20, 
            widths: ["*", 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "Additional Service",
                  fontSize: "8",
                  bold: true,
                },
                {
                  text: "Cost",
                  fontSize: "8",
                  bold: true,
                },
              ],
              [
                {
                  text: "Hydraulic Cot Dismantling/Assembling Charges",
                  fontSize: "8"
                },
                {
                  text: "849/999",
                  fontSize: "8"
                },
              ],
              [
                {
                  text: "AC Dismantling/Assembling Charges",
                  fontSize: "8"
                },
                {
                  text: "999/1499",
                  fontSize: "8"
                },
              ],
              [
                {
                  text: "Engineering wood Dismantling/Assembling Charges",
                  fontSize: "8"
                },
                {
                  text: "850/999",
                  fontSize: "8"
                },
              ],
              [
                {
                  text: "Cupboard Dismantling/Assembling Charges",
                  fontSize: "8",
                  colSpan: 2,
                },
              ],
              [
                {
                  text: "- Single Door",
                  fontSize: "8"
                },
                {
                  text: "499/499",
                  fontSize: "8"
                },
              ], [
                {
                  text: "- Double Door",
                  fontSize: "8"
                },
                {
                  text: "850/999",
                  fontSize: "8"
                },
              ],
              [
                {
                  text: "- Triple Door",
                  fontSize: "8"
                },
                {
                  text: "999/1299",
                  fontSize: "8"
                },
              ],
            ],

          },
        }

      ];
      break;
    case "order_summary":
      const order_details = all_details;

      if (order_details === null) {
        alert("Sorry details not found");
        return;
      }

      title = "PAYMENT RECEIPT";

      if (type === "order_summary") {
        newdate = momentTimeZone.utc(order_details.payment_transaction_date)
          .tz(getClientTimezone())
          .format("DD-MMM-YYYY");
      }
      window.pdfMake.fonts = {
        Montserrat: {
          normal: "Montserrat-Regular.otf",
          bold: "Montserrat-SemiBold.otf",
          italics: "Montserrat-Regular.otf",
        },
      };

      let amount_due = ["", ""];
      // if (payment_type === "token") {
      //   amount_due = [
      //     {
      //       text: "Amount Due",
      //       alignment: "right",
      //       bold: true,
      //       color: "#ee553b",
      //     },
      //     {
      //       text:
      //         "INR " +
      //         parseFloat(
      //           order_details["total_invoice_amount"] -
      //             order_details["payment"]["amount"]
      //         ).toFixed(2),
      //       alignment: "right",
      //       bold: true,
      //       color: "#ee553b",
      //     },
      //   ];
      // }

      content = [
        {
          text: "Bill To",
          color: "#EE553B",
          bold: true,
          margin: [0, 26, 0, 8],
        },
        {
          columns: [
            {
              width: "32%",
              stack: [{ bold: true, text: "Name" }, order_details["name"]],
            },
            {
              width: "32%",
              stack: [{ bold: true, text: "Email" }, order_details["email"]],
            },
            {
              width: "32%",
              stack: [{ bold: true, text: "Phone" },
              `${order_details["phone"]}${order_details["customer_alternate_phone"] !== "" ? ", " + order_details["customer_alternate_phone"] : ""}`],
            },
          ],
          margin: [0, 8],
          columnGap: 15,
        },
        {
          margin: [0, 8],
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 532,
              y2: 0,
              lineWidth: 1,
              lineColor: "#dedede",
            },
          ],
        },
        {
          columns: [
            {
              stack: [
                {
                  text: "Relocation Details",
                  bold: true,
                  margin: [0, 0, 0, 12],
                },
                {
                  text: [
                    { text: "Property Size: ", bold: true },
                    order_details["property_size"],
                  ],
                },
                // {
                // 	text: [
                // 		{ text: "Total Items: ", bold: true },
                // 		order_details["total_items"],
                // 	],
                // },
                {
                  text: [
                    { text: "DOS: ", bold: true },
                    momentTimeZone
                      .utc(order_details["moving_on"])
                      .tz(getClientTimezone())
                      .format("MMM D[, ]YYYY hh:mm a"),
                  ],
                },
              ],
              width: "32%",
            },
            {
              width: "32%",
              stack: [
                { text: "Origin", bold: true, margin: [0, 0, 0, 12] },
                {
                  text: [
                    { text: "City: ", bold: true },
                    order_details["from_city"],
                  ],
                },
                {
                  text: [
                    { text: "Address: ", bold: true },
                    order_details["moving_from"],
                  ],
                },
              ],
            },
            {
              width: "32%",
              stack: [
                { text: "Destination", bold: true, margin: [0, 0, 0, 12] },
                {
                  text: [
                    { bold: true, text: "City: " },
                    order_details["to_city"],
                  ],
                },
                {
                  text: [
                    { bold: true, text: "Address: " },
                    order_details["moving_to"],
                  ],
                },
              ],
            },
          ],
          margin: [0, 8],
          columnGap: 15,
        },
        {
          margin: [0, 8],
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 532,
              y2: 0,
              lineWidth: 1,
              lineColor: "#dedede",
            },
          ],
        },
        {
          table: {
            widths: ["*", 90],
            headerRows: 1,
            body: [
              [
                {
                  text: "Description",
                  style: "tableHeader",
                  color: "#EE553B",
                  bold: true,
                },
                {
                  text: "Amount",
                  style: "tableHeader",
                  color: "#EE553B",
                  bold: true,
                  alignment: "right",
                },
              ],
              [
                {
                  text: [
                    "Payment - ",
                    {
                      text: payment_type.replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                      }),
                      bold: true,
                    },
                  ],
                },
                {
                  text:
                    "INR " +
                    parseFloat(order_details["payment"]["amount"]).toFixed(2),
                  alignment: "right",
                },
              ],
              [
                {
                  text: "Sub total",
                  alignment: "right",
                },
                {
                  text:
                    "INR " +
                    parseFloat(order_details["payment"]["amount"]).toFixed(2),
                  alignment: "right",
                },
              ],
              [
                {
                  text: "Amount Received",
                  bold: true,
                  alignment: "right",
                },
                {
                  text:
                    "INR " +
                    parseFloat(order_details["payment"]["amount"]).toFixed(2),
                  bold: true,
                  alignment: "right",
                },
              ],
              amount_due,
            ],
          },
          layout: "noBorders",
        },
        {
          text: "Payment Information",
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 8],
        },
        {
          text: "Payment Method",
          bold: true,
        },
        {
          text: order_details["payment"]["paymentMode"].toUpperCase(),
        },
        {
          text: "Transaction No: " + order_details["payment"]["referenceId"],
        },
      ];
      break;
    case "final_invoice":
      const bill_details = all_details;
      if (bill_details === null) {
        alert("Sorry details not found");
        return;
      }
      if (type === "final_invoice") {
        newdate = momentTimeZone.utc(bill_details.completed_date)
          .tz(getClientTimezone())
          .format("DD-MMM-YYYY");
      }
      if (bill_details["quote"] === null) {
        alert("Sorry details not found");
      } else {
        if (
          bill_details["quote"]["sales_summary"]["gst_charge"] !== undefined &&
          bill_details["quote"]["sales_summary"]["gst_charge"] > 0
        ) {
          title = "TAX INVOICE";
          invoice_number = bill_details["invoice_number"];
        } else {
          title = "PAID INVOICE";
          invoice_number = bill_details["invoice_number"];
        }

        window.pdfMake.fonts = {
          Montserrat: {
            normal: "Montserrat-Regular.otf",
            bold: "Montserrat-SemiBold.otf",
            italics: "Montserrat-Regular.otf",
          },
        };

        // const vendor_logo = document.querySelector("#final_invoice_" + id + " ~ img")
        // var canvas = document.createElement("canvas");
        // canvas.height = vendor_logo.height
        // canvas.width = vendor_logo.width
        // let context = canvas.getContext('2d');

        // context.drawImage(vendor_logo, 0, 0);
        // var pngUrl = canvas.toDataURL('image/jpeg');

        // imageObj = {
        // 	image: pngUrl,
        // 	width: 80,
        // }

        let bill;

        if (Object.keys(bill_details["quote"]).length > 0) {
          bill = [
            [
              {
                text: "Sl No.",
                style: "tableHeader",
                bold: true,
                color: "#EE553B",
              },
              {
                text: "Description",
                style: "tableHeader",
                bold: true,
                color: "#EE553B",
              },
              {
                text: "Amount",
                style: "tableHeader",
                bold: true,
                color: "#EE553B",
                alignment: "right",
              },
            ],
          ];
          var indexCount = 0;
          bill_details["quote"]["items"].forEach((charge, index) => {
            if (charge.category !== "gst_charge") {
              if (charge.sales_info.amount > 0 || charge.sales_info.description.trim() !== "") {
                bill.push([
                  indexCount + 1,
                  [{ text: charge.display_name, bold: true }, { text: charge.sales_info["description"] }],
                  {
                    text: "INR " +
                      parseFloat(charge.sales_info.amount).toFixed(2),
                    alignment: "right",
                  },
                ]);
                bill.push([{
                  colSpan: 3,
                  canvas: [
                    {
                      type: "line",
                      x1: 0,
                      y1: 0,
                      x2: 532,
                      y2: 0,
                      lineWidth: 1,
                      lineColor: "#dedede",
                    },
                  ]
                }]);
                indexCount++;
              }
            }
          });
          function getDiscountAmount(bill_details) {
            let discountAmount = 0;
            if (bill_details["quote"]["sales_summary"]["discount"]) {
              if (Number(bill_details["quote"]["sales_summary"]["discount"]["amount"]) > 0) {
                discountAmount = Number(bill_details["quote"]["sales_summary"]["discount"]["amount"]);
              }
            }
            return discountAmount;
          }

          const getDiscountLabel = (discount, quote) => {
            return "Discount " + (quote["sales_summary"]["discount"]["type"] === "percentage" ? `[${quote["sales_summary"]["discount"]["value"]}%]` : `[₹${discount}]`);
          }

          const discountAmount = getDiscountAmount(bill_details);
          if (
            bill_details["quote"]["sales_summary"]["total"] !== undefined &&
            bill_details["quote"]["sales_summary"]["total"] > 0
          ) {
            // const gst_charges =
            //   bill_details["quote"]["sales_summary"]["gst_charge"] === undefined
            //     ? 0
            //     : bill_details["quote"]["sales_summary"]["gst_charge"];
            bill.push([
              "",
              { text: "Sub Total", alignment: "right" },
              {
                text:
                  "INR " +
                  parseFloat(
                    bill_details["quote"]["sales_summary"]["sub_total"]
                  ).toFixed(2),
                alignment: "right",
              },
            ]);
          }
          if (discountAmount > 0) {
            bill.push([
              "",
              { text: getDiscountLabel(discountAmount, bill_details["quote"]), alignment: "right" },
              {
                text:
                  "INR " +
                  parseFloat(
                    discountAmount
                  ).toFixed(2),
                alignment: "right",
              },
            ]);
          }
          if (
            bill_details["quote"]["sales_summary"]["gst_charge"] !== undefined &&
            bill_details["quote"]["sales_summary"]["gst_charge"] > 0
          ) {
            bill.push([
              "",
              { text: bill_details["tax_data"] === null ? "GST" : `${bill_details["tax_data"]["tax_name"]} [${bill_details["tax_data"]["tax_value"]}%]`, alignment: "right" },
              {
                text:
                  "INR " +
                  parseFloat(bill_details["quote"]["sales_summary"]["gst_charge"]).toFixed(2),
                alignment: "right",
              },
            ]);
          }
          if (
            bill_details["quote"]["sales_summary"]["total"] !== undefined &&
            bill_details["quote"]["sales_summary"]["total"] > 0
          ) {
            bill.push([
              "",
              { text: "Total", alignment: "right" },
              {
                text:
                  "INR " +
                  parseFloat(bill_details["quote"]["sales_summary"]["total"]).toFixed(2),
                alignment: "right",
              },
            ]);
          }
          bill.push([
            "",
            { text: "Payment Made", alignment: "right", bold: true },
            {
              text:
                "INR " + parseFloat(bill_details["payment_made"]).toFixed(2),
              alignment: "right",
              bold: true,
            },
          ]);
        } else {
          bill = ["", "", ""];
        }
        content = [
          {
            columnGap: 15,
            columns: [
              {
                width: "33%",
                stack: [
                  {
                    text: "Service Provided",
                    color: "#EE553B",
                    bold: true,
                    margin: [0, 0, 0, 8],
                  },
                  {
                    text: bill_details["business_name"],
                    bold: true,
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: bill_details["vendor_address"],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: [
                      { bold: true, text: "GSTIN: " },
                      bill_details["GSTIN_number"],
                    ],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: [
                      { bold: true, text: "PAN: " },
                      bill_details["pan_number"],
                    ],
                    margin: [0, 0, 0, 4],
                  },
                ],
              },
              {
                width: "33%",
                stack: [
                  {
                    text: "Billing To",
                    color: "#EE553B",
                    bold: true,
                    margin: [0, 0, 0, 8],
                  },
                  {
                    bold: true,
                    text: bill_details["name"],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text:
                      bill_details["billing_address"],
                    margin: [0, 0, 0, 4],
                  },
                  { text: bill_details["email"], margin: [0, 0, 0, 4] },
                  { text: `${bill_details["phone"]}${bill_details["customer_alternate_phone"] !== "" ? ", " + bill_details["customer_alternate_phone"] : ""}`, margin: [0, 0, 0, 4] },
                ],
              },
              {
                width: "33%",
                stack: [
                  {
                    text: "Order details",
                    color: "#FFFFFF",
                    margin: [0, 0, 0, 8],
                  },
                  {
                    text: [{ bold: true, text: "Order No: " }, id],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: [
                      { bold: true, text: "Order Date: " },
                      momentTimeZone.utc(bill_details["order_date"])
                        .tz(getClientTimezone())
                        .format("ll"),
                    ],
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: [
                      { bold: true, text: "Place of supply: " },
                      bill_details["place_of_supply"],
                    ],
                    margin: [0, 0, 0, 4],
                  },
                ],
              },
            ],
            margin: [0, 16],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 532,
                y2: 0,
                lineWidth: 1,
                lineColor: "#dedede",
              },
            ],
          },
          {
            table: {
              dontBreakRows: true,
              keepWithHeaderRows: 1,
              // heights: 10,
              widths: [40, 350, 130],
              headerRows: 1,
              body: bill,
            },
            layout: "noBorders",
            margin: [0, 12, 0, 0],
          },
        ];
      }
      break;
    default:
      break;
  }

  if (title !== undefined) {
    let extra_text;
    extra_text =
      title === "PAYMENT RECEIPT"
        ? [{ text: "Please Note: ", bold: true }, "This is not a GST invoice"]
        : title === "PAID INVOICE" || title === "TAX INVOICE"
          ? [
            { text: "Disclaimer: ", bold: true },
            "This is a computer generated invoice. Does not require any signature.",
          ]
          : "";

    let header_date = "Dated: " + newdate;
    let header_number = "No. " + id;
    if (title === "PAID INVOICE") {
      header_number = "No. " + invoice_number;
    }
    if (title === "TAX INVOICE") {
      header_number = "No. " + invoice_number;
    }
    if (title === "PAYMENT RECEIPT") {
      header_number = "Order No. " + id;
    }

    var docDefinition = {
      defaultStyle: {
        font: "Montserrat",
      },
      pageMargins: [32, 100, 32, 80],
      header: function (currentPage, pageCount) {
        if (currentPage === 1)
          return {
            columns: [
              imageObj,
              [
                {
                  text: title,
                  fontSize: "25",
                  alignment: "right",
                  margin: [0, 2],
                  bold: true,
                },
                {
                  text: header_number,
                  alignment: "right",
                  margin: [0, 2],
                },
                {
                  text: header_date,
                  alignment: "right",
                },
              ],
            ],
            margin: 16,
          };
        else return { columns: [imageObj2], margin: 16 };
      },
      footer: [
        {
          image: footer_bg,
          absolutePosition: { x: 0, y: 20 },
        },
        {
          text: extra_text,
          alignment: "center",
          absolutePosition: { x: 0, y: 0 },
        },
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Brainsys Technologies Pvt Ltd, No. 26/10, 6th Cross, Ramanna Compound,",
                  fontSize: 8,
                  alignment: "center",
                },
              ],
              [{
                text: "Mangammanapalya, Bommanahalli, HSR Layout, Bengaluru, Karnataka - 560068",
                fontSize: 8,
                alignment: "center",
              }],
              [
                {
                  text: "8884448117 | support@boxigo.in",
                  fontSize: 8,
                  alignment: "center",
                },
              ],
            ],
          },
          layout: "noBorders",
          absolutePosition: { x: 0, y: 30 },
        },
      ],
      content,
    };

    window.pdfMake.createPdf(docDefinition).open();
  }
}